// src/unicodex_ui/components/TopNav.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/TopNav.css";
import logo from "../assets/logo.png";

function TopNav() {
  const navItems = [
    { to: "/", label: "Home", end: true },
    { to: "/verify", label: "Verify" },
    { to: "/register", label: "Register Product" },
    { to: "/apply", label: "Manufacturer Prefix" },
    { to: "/docs", label: "Docs" },
  ];

  return (
    <header className="ucx-header">
      <div className="ucx-container ucx-header-inner">
        <div className="ucx-brand">
          {/* Replace with <img src={logo} alt="UNI-CODEX Logo" className="ucx-logo" /> later */}
          <img src={logo} alt="UNI-CODEX Logo" className="ucx-logo" />
          <div>
            <div className="ucx-brand-title">UNI-CODEX</div>
            <div className="ucx-brand-subtitle">
              Universal Anti-Counterfeit Identity &amp; Verification
            </div>
          </div>
        </div>
        <nav className="ucx-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                "ucx-nav-link" + (isActive ? " ucx-nav-link-active" : "")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default TopNav;
